import React from "react";
import Layout from "../components/Layout/Layout";
import "../styles/breadcrumb.css";

const Breadcrumb = () => {
  return (
    <nav className="breadcrumb-container">
      <ul className="breadcrumb">
        <li><a href="/">Home</a></li>
        <li><a href="/releases">Release</a></li>
        <li className="active">Release Notes 1.0</li>
      </ul>
    </nav>
  );
};

const ReleaseNotes = () => {
  return (
    <Layout>
      <div className="release-notes-container">
        {/* Add Breadcrumb Component */}
        <Breadcrumb />

        <header className="release-header">
          <h1 className="marginBottom10px">Release Notes</h1>
          <h2>Finkoda Web Application v1.0</h2>
          <p><strong>Release Date:</strong> March 28, 2025</p>
        </header>

        <section className="overview-section">
          <h3 className="overview">Overview</h3>
          <p>
            Finkoda is a next-generation personal finance and asset management
            platform, designed to empower users with secure, scalable, and user-friendly
            tools to manage their financial portfolios efficiently. This initial release
            lays a strong foundation with essential features that help users organize financial
            data, enhance security, and gain actionable insights through an intuitive interface.
          </p>
        </section>

        <section className="features-section">
          <h3>Features</h3>
          <ul className="custom-list">
            <li >
              <strong> UI Color Updates</strong>
              <p className="marginTop5px"> We’ve refreshed the design of our platform with UI Color Updates to enhance the user experience. These changes are aimed at creating a visually appealing and consistent interface, ensuring that the design is not only aesthetically pleasing but also easier to navigate.</p>
            </li>
            <li>
              <strong>Share Market News Added</strong>
              <p className="marginTop5px"> This new feature allows you to stay updated on the latest market movements, stock performance, trading insights, and critical financial news, all in real-time. The Share Market News feature is designed to empower you with the latest information to make well-informed investment decisions.</p>
            </li>
            
            <li>
              <strong>Key Updates:</strong>
              <ul className="custom-list">
                <li>New Color Scheme:
                  <ul className="custom-list">
                    <li> A modern color palette has been introduced to improve readability and add a fresh look to the app. The new colors are designed to provide better contrast.</li>
                    
                  </ul>
                </li>
                <li>Enhanced Accessibility: 
                  <ul className="custom-list">
                    <li> We've made sure the updated color palette is more accessible, ensuring that users with different visual preferences or impairments can have a more enjoyable experience.</li> 
                  </ul>
                </li>
                <li>Improved Branding: 
                  <ul className="custom-list">
                    <li>The updated colors align with our brand identity, offering a more cohesive and polished presentation across all areas of the app.</li> 
                  </ul>
                </li>
              </ul>
            </li>

          </ul>
        </section>

        <section className="improvements-section">
          <h3>Improvements</h3>
          <ul className="custom-list">
            <li><strong>Performance Optimizations</strong> - Faster data retrieval and improved dashboard load times for a seamless user experience.</li>
            <li><strong> Application Presentation Improvised</strong>
              <ul className="custom-list">
                <li>We’ve enhanced the overall presentation of the app, focusing on improving the layout and the way information is displayed. This update ensures a more polished and cohesive design, improving how content is organized and making the application easier to navigate.</li>
              </ul>
            </li>
            <li><strong>Scalability Upgrades</strong> - Strengthened backend infrastructure to support future feature expansions and ensure system reliability</li>
            <li><strong>Streamlined Layouts</strong> - The main dashboard and other key sections now feature a cleaner, more organized layout with optimized spacing and well-structured content.</li>
          </ul>
        </section>

        <section className="known-issues-section">
          <h3 className="marginBottom10px">Known Issues</h3>
          <p>Network Latency: Users may experience occasional delays in data synchronization due to ongoing network optimizations. Our engineering team is actively working on solutions in upcoming updates.</p>
        </section>

        <section className="important-notes-section">
          <h3>Important Notes</h3>
          <ul className="custom-list">
            <li><strong>Data Backup Advisory</strong> - We strongly recommend backing up your financial data before making any updates to avoid accidental data loss</li>
            <li><strong>Feedback & Support</strong> - Your feedback is invaluable to us! If you encounter any issues or have suggestions, please reach out to us at <a href="mailto:contact@finkoda.com">contact@finkoda.com</a>.</li>
          </ul>
        </section>

        <footer className="release-footer">
          <p>Thank you for choosing Finkoda as your trusted financial partner!</p>
        </footer>

       
      </div>
    </Layout>
  );
};

export default ReleaseNotes;
